module.exports = __webpack_public_path__ + "img/about-b-slide2.ead77c16.jpg";